<div class="mx-auto max-w-[90rem] py-6">
  <h1 id="network-operations-heading" class="px-2 pb-4">Network Operations</h1>

  <article
    aria-labelledby="network-operations-heading"
    class="mx-auto w-full rounded-2xl bg-white p-6 shadow-sm transition-[padding] duration-300 ease-in-out"
  >
    <section aria-labelledby="what-we-do">
      <h2 id="what-we-do">
        <a
          class="group inline-flex items-center gap-2 rounded-sm text-black no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
          [routerLink]="[]"
          [fragment]="'what-we-do'"
          aria-label="Link to What we do section"
        >
          <span
            class="-ml-5 hidden text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 md:inline"
            aria-hidden="true"
            >#</span
          >
          <span>What we do</span>
        </a>
      </h2>

      <p class="mb-3">
        The Network Operations Center (NOC) strives to put customer satisfaction
        at the forefront of every aspect of our support model. Our NOC would be
        the first point of contact for any issues that may arise with your
        service after the service has been installed. This would include
        addressing any problems negatively impacting your service, change
        management, coordinating maintenance activity and analyzing and
        responding to deviations in our network performance monitoring.
      </p>
      <p class="mb-3">
        Our focus is clear and consistent communication, timely updates, and
        one-time resolution of any problems that may arise. Our technicians are
        available 24x7x365 to assist you in any way we can with the vast
        majority of our calls being answered and attended to in under 20
        seconds.
      </p>
      <p class="mb-3">We look forward to helping you in any way we can!</p>
    </section>

    <section aria-labelledby="contact-us">
      <h2 id="contact-us" class="mt-8 mb-3">
        <a
          class="group inline-flex items-center gap-2 rounded-sm text-black no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
          [routerLink]="[]"
          [fragment]="'contact-us'"
          aria-label="Link to Contact Us section"
        >
          <span
            class="-ml-5 hidden text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 md:inline"
            aria-hidden="true"
            >#</span
          >
          <span>Contact Us</span>
        </a>
      </h2>

      <div
        class="mb-3 w-min max-w-full overflow-x-auto overflow-y-hidden rounded-md border border-gray-300 whitespace-nowrap"
      >
        <table class="overflow-hidden rounded-md border">
          <caption class="sr-only">
            Network Operations Center contact information
          </caption>
          <tbody>
            <tr>
              <th
                class="border border-gray-300 px-3 py-2 text-left font-medium"
                scope="row"
              >
                Phone Number
              </th>
              <td class="border border-gray-300 px-3 py-2">
                <a
                  href="tel:+18668920915"
                  class="rounded-sm text-blue-600 underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                  aria-label="Call the Network Operations Center at +1 866 892 0915"
                  >+1 866 892 0915</a
                >
              </td>
            </tr>
            <tr class="bg-gray-50">
              <th
                class="border border-gray-300 px-3 py-2 text-left font-medium"
                scope="row"
              >
                Outage/Technical Issues
              </th>
              <td class="border border-gray-300 px-3 py-2">
                <a
                  href="mailto:CBNnoc@comcast.com"
                  class="rounded-sm text-blue-600 underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                  aria-label="Email outage or technical issues at CBNnoc@comcast.com"
                  >CBNnoc&#64;comcast.com</a
                >
              </td>
            </tr>
            <tr>
              <th
                class="border border-gray-300 px-3 py-2 text-left font-medium"
                scope="row"
              >
                Change Management
              </th>
              <td class="border border-gray-300 px-3 py-2">
                <a
                  href="mailto:CBNnoc@comcast.com"
                  class="rounded-sm text-blue-600 underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                  aria-label="Email change management at CBNnoc@comcast.com"
                  >CBNnoc&#64;comcast.com</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="mb-3 font-semibold italic">
        Please dial in for all urgent issues and Escalation requests to ensure a
        timely response.
      </p>

      <h2 id="noc-contacts" class="mt-8 mb-3">
        <a
          class="group inline-flex items-center gap-2 rounded-sm text-black no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
          [routerLink]="[]"
          [fragment]="'noc-contacts'"
          aria-label="Link to NOC Contacts and Escalation Procedures section"
        >
          <span
            class="-ml-5 hidden text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 md:inline"
            aria-hidden="true"
            >#</span
          >
          <span>NOC Contacts & Escalation Procedures</span>
        </a>
      </h2>

      <div class="mb-3">
        <app-severity-level-contacts-grid
          caption="NOC contacts and escalation procedures"
          [severityLevelContacts]="nocSeverityLevelContacts"
        />
      </div>

      <h2 id="msc-contacts" class="mt-8 mb-3">
        <a
          class="group inline-flex items-center gap-2 rounded-sm text-black no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
          [routerLink]="[]"
          [fragment]="'msc-contacts'"
          aria-label="Link to MSC Contacts and Escalation Procedures section"
        >
          <span
            class="-ml-5 hidden text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 md:inline"
            aria-hidden="true"
            >#</span
          >
          <span>MSC Contacts & Escalation Procedures</span>
        </a>
      </h2>

      <div class="mb-3">
        <app-severity-level-contacts-grid
          caption="MSC contacts and escalation procedures"
          [severityLevelContacts]="mscSeverityLevelContacts"
        />
      </div>

      <h2 id="severity-definitions" class="mt-8 mb-3 italic">
        <a
          class="group inline-flex items-center gap-2 rounded-sm text-black no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
          [routerLink]="[]"
          [fragment]="'severity-definitions'"
          aria-label="Link to Severity Definitions section"
        >
          <span
            class="-ml-5 hidden text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 md:inline"
            aria-hidden="true"
            >#</span
          >
          <span>Severity Definitions</span>
        </a>
      </h2>

      <div class="text-sm">
        <h3 id="5th-level" class="mb-1 text-base">
          <a
            class="group inline-flex items-center gap-2 rounded-sm text-black no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
            [routerLink]="[]"
            [fragment]="'5th-level'"
            aria-label="Link to Severity 5 definition"
          >
            <span
              class="-ml-5 hidden text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 md:inline"
              aria-hidden="true"
              >#</span
            >
            <strong>Severity 5:&nbsp;</strong>
            <span class="opacity-70">(Highest)</span>
          </a>
        </h3>
        <ul class="mb-3 ml-4 list-inside list-disc">
          <li>Critical network failure</li>
          <li>Entire network or systems down or inoperative</li>
          <li>Service affecting event &mdash; Severe business impact</li>
          <li>Continuous network performance impairment</li>
          <li>
            <span class="font-semibold">Resolution ETAs:</span>
            <ul class="ml-4 list-inside list-disc">
              <li><b>Tech on Duty:</b> Immediate</li>
              <li><b>Sr. Tech / MSC Engineer on Duty:</b> 1 hour</li>
              <li><b>Manager:</b> 4 hours</li>
              <li><b>VP Level:</b> 16 hours</li>
            </ul>
          </li>
        </ul>

        <h3 id="4th-level" class="mb-1 text-base">
          <a
            class="group inline-flex items-center gap-2 rounded-sm text-black no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
            [routerLink]="[]"
            [fragment]="'4th-level'"
            aria-label="Link to Severity 4 definition"
          >
            <span
              class="-ml-5 hidden text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 md:inline"
              aria-hidden="true"
              >#</span
            >
            <strong>Severity 4:&nbsp;</strong>
            <span class="opacity-70">(High)</span>
          </a>
        </h3>
        <ul class="mb-3 ml-4 list-inside list-disc">
          <li>Significant network degradation</li>
          <li>Service affecting &mdash; business impact</li>
          <li>
            <span class="font-semibold">Resolution ETAs:</span>
            <ul class="ml-4 list-inside list-disc">
              <li><b>Tech on Duty:</b> Immediate</li>
              <li><b>Sr. Tech / MSC Engineer on Duty:</b> 4 hours</li>
              <li><b>Manager:</b> 8 hours</li>
              <li><b>VP Level:</b> 48 hours</li>
            </ul>
          </li>
        </ul>

        <h3 id="3rd-level" class="mb-1 text-base">
          <a
            class="group inline-flex items-center gap-2 rounded-sm text-black no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
            [routerLink]="[]"
            [fragment]="'3rd-level'"
            aria-label="Link to Severity 3 definition"
          >
            <span
              class="-ml-5 hidden text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 md:inline"
              aria-hidden="true"
              >#</span
            >
            <strong>Severity 3:&nbsp;</strong>
            <span class="opacity-70">(Normal)</span>
          </a>
        </h3>
        <ul class="mb-3 ml-4 list-inside list-disc">
          <li>Minor network or system event/impairment</li>
          <li>Service affecting &mdash; minimal business impact</li>
          <li>Low priority</li>
          <li>
            <span class="font-semibold">Resolution ETAs:</span>
            <ul class="ml-4 list-inside list-disc">
              <li><b>Tech on Duty:</b> Immediate</li>
              <li><b>Sr. Tech / MSC Engineer on Duty:</b> 48 hours</li>
              <li><b>Manager:</b> As Needed</li>
              <li><b>VP Level:</b> As Needed</li>
            </ul>
          </li>
        </ul>

        <h3 id="2nd-level" class="mb-1 text-base">
          <a
            class="group inline-flex items-center gap-2 rounded-sm text-black no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
            [routerLink]="[]"
            [fragment]="'2nd-level'"
            aria-label="Link to Severity 2 definition"
          >
            <span
              class="-ml-5 hidden text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 md:inline"
              aria-hidden="true"
              >#</span
            >
            <strong>Severity 2:&nbsp;</strong>
            <span class="opacity-70">(Low)</span>
          </a>
        </h3>
        <ul class="mb-3 ml-4 list-inside list-disc">
          <li>Passive network or system issue/event</li>
          <li>Configuration and Design</li>
          <li>General Question</li>
          <li>Change Control</li>
          <li>
            <span class="font-semibold">Resolution ETAs:</span>
            <ul class="ml-4 list-inside list-disc">
              <li><b>Tech on Duty:</b> Immediate</li>
              <li><b>Sr. Tech / MSC Engineer on Duty:</b> As Needed</li>
              <li><b>Manager:</b> As Needed</li>
              <li><b>VP Level:</b> As Needed</li>
            </ul>
          </li>
        </ul>
      </div>
    </section>

    <section aria-labelledby="proactive-monitoring">
      <h2 id="proactive-monitoring" class="mt-8 mb-3">
        <a
          class="group inline-flex items-center gap-2 rounded-sm text-black no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
          [routerLink]="[]"
          [fragment]="'proactive-monitoring'"
          aria-label="Link to Proactive Monitoring and Notification Standards section"
        >
          <span
            class="-ml-5 hidden text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 md:inline"
            aria-hidden="true"
            >#</span
          >
          <span>Proactive Monitoring and Notification Standards</span>
        </a>
      </h2>
      <p class="mb-3">
        We proactively monitor Node/Device reachability of our managed CPE
        device every five (5) minutes with a failure being recognized if the
        device misses three (3) consecutive polling intervals. If there is a
        node reachability, a trouble ticket will automatically open and send an
        e-mail alert to the customer's Primary Outage Contact with the trouble
        ticket and a note for the customer to confirm the outage.
      </p>
      <p class="mb-3">
        This ticket will be set in to a “Pending Customer” status until the
        customer confirms the outage is genuine, and there is no local power
        issue or inside wiring work being performed at the customer premise.
        Once the customer confirms there is a genuine service issue, they should
        contact the NOC via phone, while referencing the Proactive Ticket
        number. The Proactive Ticket will then go in to a “Working” status, and
        the NOC will move forward to troubleshoot and isolate the problem. This
        change in status marks the beginning of the time interval for issue
        resolution.
      </p>
      <p class="mb-3">
        If the customer does not notify the NOC of any service affecting
        condition or issue, the trouble ticket will be automatically closed in
        24 hours from the time of the initial notification if the service issues
        resolves. If the site remains unreachable, our ticket will remain open
        pending customer confirmation.
      </p>
      <ul class="mb-3 ml-4 list-inside list-disc">
        <li>
          Our NOC will require a site Local Contact name, phone number and site
          access-hours to open a ticket with our underlying vendors for
          investigation.
        </li>
        <li>
          Power should be verified to all equipment attached to the service.
        </li>
      </ul>
    </section>

    <section aria-labelledby="change-management">
      <h2 id="change-management" class="mt-8 mb-3">
        <a
          class="group inline-flex items-center gap-2 rounded-sm text-black no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
          [routerLink]="[]"
          [fragment]="'change-management'"
          aria-label="Link to Change Management Support section"
        >
          <span
            class="-ml-5 hidden text-gray-400 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 md:inline"
            aria-hidden="true"
            >#</span
          >
          <span>Change Management (Support)</span>
        </a>
      </h2>
      <ul class="mb-3 ml-4 list-inside list-disc">
        <li>
          All non-service affecting change requests should be submitted via
          email to
          <a
            href="mailto:CBNnoc@comcast.com"
            class="rounded-sm text-blue-600 underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
            aria-label="Email change management at CBNnoc@comcast.com"
            >CBNnoc&#64;comcast.com</a
          >.
        </li>
        <li>
          Non-service affecting change management events are defined as items
          such as CPE Configuration Changes, Firewall Changes, Routing Changes,
          and Utilization Report Requests.
        </li>
        <li>
          These non-service affecting change requests are managed by the Support
          Team during normal business hours of 8:00am to 8:00pm Central, Monday
          – Friday.
        </li>
        <li>
          An acknowledgement of receipt for the change management request will
          be made within 2 hours.
        </li>
        <li>
          Most change management request are completed within 24 &ndash; 72
          hours, with Expedites being completed same day.
        </li>
        <li>
          If additional time is needed to process your request, Support
          <a
            href="mailto:CBNnoc@comcast.com"
            class="rounded-sm text-blue-600 underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
            aria-label="Email support at CBNnoc@comcast.com"
            >CBNnoc&#64;comcast.com</a
          >
          will provide more details regarding any delays.
        </li>
        <li>
          Change Requests requested outside of the normal business hours of
          8:00am to 8:00pm Central, Monday &ndash; Friday will be subject to
          additional professional services fees.
        </li>
      </ul>
    </section>
  </article>
</div>
